import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';

import './Legend.css';

let items = [
    {name: 'Classrooms', hexClr: '#F68D51'},
    {name: 'Offices', hexClr: '#55ABC6'},
    {name: 'Team Rooms', hexClr: '#B097C8'},
    {name: 'Labs', hexClr: '#D74D9C'},
    {name: 'Shared Space', hexClr: '#FBE284'},
    {name: 'Support Space', hexClr: '#E3D2BE'}];


@inject("appStore")
@observer
class Legend extends Component {
    getItem = () => {
        items.map
        return ('hello');
    };

    getStyle = (clr) => {
        return ({'backgroundColor': clr});
    };

    render() {

        let elems = items.map((elem) => {
            return (
                <div className="legend_item">
                    <div style={this.getStyle(elem['hexClr'])} className="legend_clr"></div>
                    <div className="legend_item_name">{elem['name']}</div>
                </div>
            );
        });

        return (
            <div className="legend">
                {elems}
            </div>
        );

    }
}

export default Legend;





// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/Legend/index.js